import { Button, Typography } from '@breetometer/components';
import { CopyIcon } from 'BreetAssets';
import { copyToClipboard, truncateWithEllipsis } from 'BreetHelpers';

import type { ITransactionMobileColumnLeft } from '../TransactionsMobileColumn.helpers';

const MobileColumnLeft = ({ value, valueCopy, date, onClick, children, truncate }: ITransactionMobileColumnLeft) => (
	<Button
		variant='native'
		className='datatable_mobilecolumnleft'
		onClick={onClick}
	>
		{children ?? (
			<>
				<div className='flex-row-center'>
					<Typography
						as='h6'
						className='color-neutral-50'
					>
						{truncate ? truncateWithEllipsis(value ?? '...') : value}
					</Typography>
					&nbsp;
					{valueCopy && (
						<CopyIcon
							variant='plain'
							className='svg-dark'
							aria-label='Copy value'
							role='button'
							tabIndex={0}
							onClick={copyToClipboard(value, 'copied')}
						/>
					)}
				</div>
				<Typography className='color-primary-100'>{date}</Typography>
			</>
		)}
	</Button>
);

export default MobileColumnLeft;
